export default {
  leaveTypes(state, value) {
    return (state.leaveTypes = value);
  },
  leaveTypeTotal(state, total) {
    return (state.leaveTypeTotal = total);
  },
  leaveTotal(state, total) {
    return (state.leaveTotal = total);
  },
  viewContainerLoading(state, value) {
    return (state.viewContainerLoading = value);
  },
  totalLeaveApprover(state, total) {
    return (state.totalLeaveApprover = total);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  branches(state, value) {
    return (state.branches = value);
  },
  departments(state, value) {
    return (state.departments = value);
  },
  currentLeaveType(state, leaveType) {
    return (state.currentLeaveType = leaveType);
  },
  leaveApprovers(state, value) {
    return (state.leaveApprovers = value);
  },
  currentLeaveApprover(state, leaveApprover) {
    return (state.currentLeaveApprover = leaveApprover);
  },
  employees(state, value) {
    return (state.employees = value);
  },
  employeeGrades(state, value) {
    return (state.employeeGrades = value);
  },
  leavesData(state, value) {
    return (state.leavesData = value);
  },
  currentLeave(state, value) {
    return (state.currentLeave = value);
  },
  filterValue(state, value) {
    return (state.filterValue = value);
  },
  filterDate(state, value) {
    return (state.filterDate = value);
  },
  filterLeaveTypes(state, value) {
    return (state.filterLeaveTypes = value);
  },
  employeeLeave(state, value) {
    return (state.employeeLeave = value);
  },
  employeeLeaveEmployeeId(state, value) {
    state.employeeLeaveEmployeeId = value;
    state.employeeLeave = [];
  },
  leaveTypesSearch(state, value) {
    return (state.leaveTypesSearch = value);
  },
};
